var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full overflow-hidden"},[_c('div',{staticClass:"text-editor pell h-full overflow-hidden"})])}]

export { render, staticRenderFns }